import { defineMessages } from 'react-intl'

const messages = defineMessages({
  regional: {
    id: 'HTMLTitleController.regional',
    description: 'Texto para el title de capas 0 y 1',
    defaultMessage: 'Observatorio de Competitividad Regional'
  },
  institute: {
    id: 'HTMLTitleController.institute',
    description: 'Texto para el title de capa 0',
    defaultMessage: 'Orkestra Instituto Vasco de Competitividad'
  },
  methodology: {
    id: 'HTMLTitleController.methodology',
    description: 'Texto para el title de metodologia',
    defaultMessage: 'Metodología'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Controllers/HTMLTitle/HTMLTitleController/messages.js